var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import request from "superagent";
import { keyValueArrayToObject } from "../../utils/utils.js";

export var DigiThemeManagerContext = React.createContext();
export var DigiThemeManagerProvider = DigiThemeManagerContext.Provider;
export var DigiThemeManagerConsumer = DigiThemeManagerContext.Consumer;

/**
 * Context provider of digi theme components. Must be the parent component of any digi theme components.
 *
 * DigiThemeManagerContext or DigiThemeManagerConsumer may be used to load and obtain digi theme or dictionary configs.
 */

var DigiThemeManager = function (_Component) {
  _inherits(DigiThemeManager, _Component);

  function DigiThemeManager() {
    _classCallCheck(this, DigiThemeManager);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = { configs: {}, dictionaries: {} };
    _this.loadConfig = _this.loadConfig.bind(_this);
    _this.loadDictionary = _this.loadDictionary.bind(_this);
    _this.loadGroupRoles = _this.loadGroupRoles.bind(_this);

    _this.getConfig = _this.getConfig.bind(_this);
    _this.getDictionary = _this.getDictionary.bind(_this);
    _this.getGroupRoles = _this.getGroupRoles.bind(_this);
    return _this;
  }

  DigiThemeManager.prototype.loadConfig = function loadConfig(themeUuid) {
    var _this2 = this;

    var _props = this.props,
        adaptiveUrl = _props.adaptiveUrl,
        gmSessionId = _props.gmSessionId;

    var getDigiThemeByUuid = function getDigiThemeByUuid(themeUuid) {
      request.post(adaptiveUrl + "WebServices/generic/DigiTheme.asmx/GetDigiThemeByUuid").set("gm_session_id", gmSessionId).send({ uuid: themeUuid }).then(function (res) {
        if (!res.body.d.success) return;
        res = res.body.d;
        var data = keyValueArrayToObject(res.data);
        var jsonData = JSON.parse(data.digi_theme);
        _this2.setState(function (prevState) {
          var _extends2;

          return {
            configs: _extends({}, prevState.configs, (_extends2 = {}, _extends2[themeUuid] = { config: jsonData, loading: false }, _extends2))
          };
        });
      }).catch(function (e) {
        console.error("Could not download digi theme definition.", themeUuid, e);
      });
    };
    this.setState(function (prevState) {
      var _extends3;

      if (prevState.configs[themeUuid]) return;

      getDigiThemeByUuid(themeUuid);

      return {
        configs: _extends({}, prevState.configs, (_extends3 = {}, _extends3[themeUuid] = { loading: true }, _extends3))
      };
    });
  };

  DigiThemeManager.prototype.loadDictionary = function loadDictionary(uuid, key, value, geom) {
    var _this3 = this;

    var _props2 = this.props,
        adaptiveUrl = _props2.adaptiveUrl,
        gmSessionId = _props2.gmSessionId;

    var dictKey = uuid + "::" + key + "::" + value + (geom ? "::" + geom : "");
    var getDictionary = function getDictionary() {
      var columns = [key, value];
      if (geom && geom !== "geom") columns.push(geom);
      request.post(adaptiveUrl + "WebServices/client/DataView.asmx/ReadAny").send({
        request: {
          theme_uuid: uuid,
          columns: columns,
          filter: { filterColumns: [] },
          excludeGeometry: !geom
        }
      }).set("gm_session_id", gmSessionId).then(function (res) {
        return res.body;
      }).then(function (res) {
        res = res.d;
        if (!res.success) {
          //dispatch error
          return;
        }

        var dict = res.records.map(function (i) {
          return {
            key: i[key],
            value: i[value],
            geom_wkt: i[geom === "geom" ? "geom_wkt" : geom]
          };
        });

        _this3.setState(function (prevState) {
          var _extends4;

          return _extends({}, prevState, {
            dictionaries: _extends({}, prevState.dictionaries, (_extends4 = {}, _extends4[dictKey] = { data: dict, loading: false }, _extends4))
          });
        });
      }).catch(function (e) {
        console.error("Could not load dictionary", uuid, key, value, e);
      });
    };

    this.setState(function (prevState) {
      var _extends5;

      if (prevState.dictionaries[dictKey]) return;

      getDictionary();

      return {
        dictionaries: _extends({}, prevState.dictionaries, (_extends5 = {}, _extends5[dictKey] = { loading: true }, _extends5))
      };
    });
  };

  DigiThemeManager.prototype.loadGroupRoles = function loadGroupRoles() {
    var _this4 = this;

    var adaptiveUrl = this.props.adaptiveUrl;

    request.post(adaptiveUrl + "WebServices/generic/Role.asmx/Read").send({
      start: 0,
      limit: 0,
      filter: { filterColumns: [{ name: "role_type", value: 2 }] }
    }).then(function (res) {
      return res.body;
    }).then(function (res) {
      if (!res.d.success) {
        console.error("Could not load group roles", res.d);
        return;
      }

      _this4.setState({ groupRoles: res.d.records });
    }).catch(function (e) {
      console.error("Could not load group roles", e);
    });
  };

  DigiThemeManager.prototype.getConfig = function getConfig(themeUuid) {
    var themeConfig = this.state.configs[themeUuid];
    return themeConfig && themeConfig.config || null;
  };

  DigiThemeManager.prototype.getDictionary = function getDictionary(uuid, key, value, geom) {
    var dict = this.state.dictionaries[uuid + "::" + key + "::" + value + (geom ? "::" + geom : "")];
    return dict && dict.data || null;
  };

  DigiThemeManager.prototype.getGroupRoles = function getGroupRoles() {
    return this.state.groupRoles;
  };

  DigiThemeManager.prototype.render = function render() {
    var _props3 = this.props,
        children = _props3.children,
        gmSessionId = _props3.gmSessionId,
        adaptiveUrl = _props3.adaptiveUrl,
        srid = _props3.srid;


    return React.createElement(
      DigiThemeManagerProvider,
      {
        value: {
          loadConfig: this.loadConfig,
          loadDictionary: this.loadDictionary,
          loadGroupRoles: this.loadGroupRoles,
          getConfig: this.getConfig,
          getDictionary: this.getDictionary,
          getGroupRoles: this.getGroupRoles,
          gmSessionId: gmSessionId,
          adaptiveUrl: adaptiveUrl,
          srid: srid
        }
      },
      children
    );
  };

  return DigiThemeManager;
}(Component);

export { DigiThemeManager as default };